<template>
  <v-btn icon>
    <v-menu>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            v-bind="attrs"
            v-on="on"
            icon
        >
          <v-icon>mdi-format-list-bulleted-square</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="[getOcorrencia(item) , diagEvidencias = true]">
          <v-list-item-title>
            Registrar ocorrência
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="[getOcorrencia(item),diagViewEvidencias = true]">
            <v-list-item-title>
            Visualizar ocorrências
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog width="60%" scrollable v-model="diagEvidencias" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title> Registrar nova ocorrência para o agendamento </v-card-title>
        <v-card-text class="pa-9 pt-0 pb-2" v-if="ocorrenciasList[0] != null">
          <v-row>
            <template>
              <strong>CNPJ: {{ocorrenciasList[0].CNPJ}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Razão Social: {{ocorrenciasList[0].RazaoSocial}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Titulo: {{ocorrenciasList[0].titulo}}</strong>
            </template>
          </v-row>
          <v-row>
            <template>
              <strong>Data: {{`${$moment(ocorrenciasList[0].DataInicial).format('L')}`}}</strong>
            </template>
          </v-row>
        </v-card-text>
        <v-card-text>
          <v-textarea v-model="ocorrenciaDescricao" auto-grow label="Descrição da ocorrência"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="diagEvidencias = !diagEvidencias" dark>cancelar</v-btn>
          <v-btn @click="cadOcorrencias()" color="primary" dark>registrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="60%" scrollable v-model="diagViewEvidencias" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card :loading="loading">
        <v-card-title>
          Histórico de ocorrências do agendamento
          <v-spacer></v-spacer>
          <v-btn @click="diagViewEvidencias = !diagViewEvidencias" icon>
            <v-icon>mdi-close-box</v-icon>
          </v-btn>
          <v-card-text class="pa-3 pt-3 pb-2" v-if="ocorrenciasList[0] != null">
            <v-row>
              <template>
                <strong>CNPJ: {{ocorrenciasList[0].CNPJ}}</strong>
              </template>
            </v-row>
            <v-row>
              <template>
                <strong>Razão Social: {{ocorrenciasList[0].RazaoSocial}}</strong>
              </template>
            </v-row>
            <v-row>
              <template>
                <strong>Titulo: {{ocorrenciasList[0].titulo}}</strong>
              </template>
            </v-row>
            <v-row>
              <template>
                <strong>Data: {{`${$moment(ocorrenciasList[0].DataInicial).format('L')}`}}</strong>
              </template>
            </v-row>
          </v-card-text>
        </v-card-title>
        <v-card-text class="pa-5">
              <v-timeline dense>
                  <v-timeline-item
                    v-for="ocorrencia in ocorrenciasList"
                    :key="ocorrencia.index"
                    color="primary"
                    large
                    fill-dot
                  >
                    <template v-slot:icon>
                        <v-avatar>
                            <v-icon class="white--text">mdi-format-list-bulleted-square</v-icon>
                        </v-avatar>
                    </template>
                    <v-alert border="left" color="primary" dark>
                       <h4 class="pa-2">{{ ocorrencia.Descricao }}</h4>
                      <v-divider class="white mb-2 mt-2"></v-divider>
                       <span class="subtitle-2 ma-2">
                         {{ `${$moment(ocorrencia.DataOcorrencia).format('LLL')} por ${ocorrencia.Usuario}` }}
                       </span>
              </v-alert>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-card>
    </v-dialog>
    <AlertSystem :snackbar="system.snackbar"></AlertSystem>
  </v-btn>
</template>

<script>
import AlertSystem from './AlertSystem.vue'
export default {
  name: "OcorrenciasProcesso",
  props: {
    IdAgendamento: {
      type: Number,
    },
  },
  components: {
    AlertSystem
  },
  data: () => ({
    system: {
      snackbar: {},
    },
    // Ocorrências
    diagEvidencias: false,
    diagViewEvidencias: false,
    ocorrenciasList: [],
    ocorrenciasCredenciados: [],
    ocorrenciaDescricao: "",
    loading: false
  }),
  methods: {
    getOcorrencia () {
      this.loading = true
      this.axios.get(`agendamentos/${this.IdAgendamento}/ocorrencias`).then( res => {
        this.ocorrenciasList = res.data
      }).catch( () => {

      }).finally(() => {
        this.loading = false
      })
    },
    // getCredenciados(){
    //   this.axios.get(`agendamentos/${this.IdAgendamento}/credenciados`).then(res => {
    //     this.ocorrenciasCredenciados = res.data
    //   }).catch(() => {
    //
    //   })
    // },
    cadOcorrencias () {
      this.axios.post(`agendamentos/${this.IdAgendamento}/ocorrencias`, {
        ocorrenciaDescricao: this.ocorrenciaDescricao
      }).then( res => {
        this.system.snackbar = {
          snackbar: true,
          text: res.data,
          color: "green",
        };
        this.diagEvidencias = false
        this.ocorrenciaDescricao = ''
      }).catch(e => {
        this.system.snackbar = {
          snackbar: true,
          text: e.response.data.ocorrenciaDescricao[0],
          color: "red",
        };
      })
    },
  },
};
</script>

<style>
</style>